export const themeBlue = () => '#283C5A';
export const themeGray = () => '#878787';
export const themeWhite = () => '#FFFFFFE6';
export const themeOrange = () => '#EBAF5AE6';
export const themeBlack = () => '#191919';
export const transparentBlack = () => 'rgba(25, 25, 25, .25)';
export const transparentWhite = () => 'rgba(255, 255, 255, .75)';
